import { createStore } from "zustand/vanilla";
const isTheme = (s) => s === "system" || s === "light" || s === "dark";
// #rgb or #rrggbb only — matches the <input type="color"> value format.
const isHexColor = (s) => s !== null && /^#[0-9a-fA-F]{6}$/.test(s);
// Doc 10 §6: theme preference persisted through the SecureStorage capability, so
// it survives across sessions/devices and store recreation. The accent color is the
// same kind of device-local appearance preference, so it lives in the same store.
export const createThemeStore = (deps) => {
    const key = deps.key ?? "theme";
    const accentKey = deps.accentKey ?? "accentColor";
    const store = createStore((set) => ({
        theme: "system",
        accentColor: null,
        ready: false,
        async load() {
            const [stored, storedAccent] = await Promise.all([deps.storage.getItem(key), deps.storage.getItem(accentKey)]);
            set({
                theme: isTheme(stored) ? stored : "system",
                accentColor: isHexColor(storedAccent) ? storedAccent : null,
                ready: true,
            });
        },
        async setTheme(theme) {
            set({ theme });
            await deps.storage.setItem(key, theme);
        },
        async setAccentColor(color) {
            set({ accentColor: color });
            if (color === null)
                await deps.storage.removeItem(accentKey);
            else
                await deps.storage.setItem(accentKey, color);
        },
    }));
    void store.getState().load(); // hydrate in the background
    return store;
};
//# sourceMappingURL=themeStore.js.map